
import * as handlebars_family from "../handlebars_family.ts";

const TPL = handlebars_family.addTemplate("specialdays/specialdays_empty",{"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"emptystateblock flexcenter flexcol\" style=\"height:100%\"><img src=\"/images/empty_state_illustration_special_days.svg\"><h1>"
    + ((stack1 = lookupProperty(helpers,"i18n").call(depth0 != null ? depth0 : (container.nullContext || {}),"specialdays.empty.title",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":1,"column":133},"end":{"line":1,"column":169}}})) != null ? stack1 : "")
    + "</h1><p class=\"blockmargin\">"
    + ((stack1 = lookupProperty(helpers,"i18n").call(depth0 != null ? depth0 : (container.nullContext || {}),"specialdays.empty.text",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":1,"column":197},"end":{"line":1,"column":232}}})) != null ? stack1 : "")
    + "</p><button data-fw-onclick=\"specialdayscreate\"> "
    + ((stack1 = lookupProperty(helpers,"i18n").call(depth0 != null ? depth0 : (container.nullContext || {}),"specialdays.empty.button",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":1,"column":281},"end":{"line":1,"column":318}}})) != null ? stack1 : "")
    + " </button></div> ";
},"useData":true});
export default TPL;